export default __webpack_public_path__ + "static/media/info_start.min.6da86fd0.png";